module.exports = __webpack_public_path__ + "img/moderator.8bf9d6f2.svg";